import type Immutable from 'immutable';
import { createMigration } from './utils';

/**
 * Migrates to remove animation configs for text_1 assets in talking head scenes
 */
export const migrationTo9_154 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },

    migrateScene(scene) {
        return scene.withMutations(map => {
            const sceneCategory = scene.get('sceneCategory');

            if (sceneCategory !== 'talking_head' && sceneCategory !== 'talking_head_insert') {
                return;
            }

            map.get('subslides', []).forEach((subslide, s) => {
                subslide.get('children', []).forEach((child, c) => {
                    const path = ['subslides', s, 'children', c];
                    if (map.getIn([...path, 'classType']) !== 'GraphicStyleTextAsset') {
                        return;
                    }

                    const asset = map.getIn(path) as Immutable.Map<string, any>;
                    const assetName = asset.get('name');

                    if (assetName !== 'text_1') {
                        return;
                    }

                    map.setIn([...path, 'animationConfig'], []);
                    map.setIn([...path, 'normalStyle', 'objectAnimation'], []);
                    map.setIn([...path, 'highlightStyle', 'objectAnimation'], []);
                });
            });

            // migrate asset preset in all text positions
            map.get('textPositionPresets').entrySeq().forEach(([presetPosition, textPositionPreset]) => {
                textPositionPreset.forEach((asset, assetIndex) => {
                    if (asset.get('name') === 'text_1') {
                        const presetPath = ['textPositionPresets', presetPosition, assetIndex];

                        map.setIn([...presetPath, 'normalStyle', 'objectAnimation'], []);
                        map.setIn([...presetPath, 'highlightStyle', 'objectAnimation'], []);
                    }
                });
            });
        });
    },
});
